import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'
import { supabase } from './supabase'
import { setActiveCompanyId } from './company-context'

const LAST_LAUNCH_ENV_KEY = 'pronteer.lastLaunchEnv'

export async function enforceFreshSessionOnUpdate(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return

  try {
    // The Supabase project URL identifies the environment (prod vs test).
    // We only clear the session when switching environments — not on app updates.
    const currentEnv = import.meta.env.VITE_SUPABASE_URL

    const { value: storedEnv } = await Preferences.get({
      key: LAST_LAUNCH_ENV_KEY,
    })

    console.log('[app-version] stored env:', storedEnv, 'current env:', currentEnv)

    // First launch after this guard ships: adopt the current env as baseline
    // without signing out — the existing session is valid for this environment.
    if (storedEnv === null) {
      await Preferences.set({ key: LAST_LAUNCH_ENV_KEY, value: currentEnv })
      console.log('[app-version] no stored env, baseline stored, keeping session')
      return
    }

    if (storedEnv === currentEnv) {
      console.log('[app-version] env unchanged, keeping session')
      return
    }

    console.log('[app-version] env changed — clearing session')
    await supabase.auth.signOut({ scope: 'local' })
    await setActiveCompanyId(null)
    await Preferences.set({ key: LAST_LAUNCH_ENV_KEY, value: currentEnv })
    console.log('[app-version] session cleared, new baseline stored')
  } catch (err) {
    console.warn('[app-version] fresh-session check failed', err)
  }
}
